import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import * as moment from 'moment-timezone';

@Pipe({
    name: 'convertDob',
    standalone: false
})
export class ConvertDobPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(txt) {
    if (txt === undefined)
      return 'Unknown';
    const d = new Date(txt);
    return d.toLocaleDateString('en-us', {timeZone: 'UTC'});
  }

}
